import { materialConfig } from '@/common/config';
import request from '@/utils/request';
let cachedUserInfo: any = null; // 用于缓存用户信息

/**
* @description 获取用户信息
*/
export const getUserInfo = async () => {
  // 如果用户信息已经存在，直接返回
  if (cachedUserInfo) {
    return cachedUserInfo;
  }

  try {
    const data = await request.post(`${materialConfig}/sd-biz/api/user/v1/get`, {
      method: 'post',
      data: {
        type: 20
      }
    });

    // 如果获取到用户ID，缓存用户信息
    if (data?.data?.userId) {
      cachedUserInfo = data.data;
      return cachedUserInfo;
    } else {
      return false;
    }
  } catch (e) {
    console.warn('Error fetching user info:', e); // 打印错误信息
    return false;
  }
};
